// extracted by mini-css-extract-plugin
module.exports = {"Loader":"style_Loader__3cXQ6","load2":"style_load2__1ywZJ"};